import { setToken } from "../../setup/api";
import get from "lodash/get";

export default {
  login(context, { email, password }) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/accounts/signin", { email, password })
        .then(function(response) {
          setToken(response.data.token);
          context.commit("setLogged", true);
          resolve(response.data);
        })
        .catch(reject);
    });
  },

  validateToken(context, token) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/accounts/register/${token}`)
        .then(resolve)
        .catch(reject);
    });
  },

  register(context, { token, name, email, password }) {
    const data = {
      name,
      email,
      password
    };

    return new Promise((resolve, reject) => {
      window.axios
        .post(`/accounts/register/${token}`, data)
        .then(function(response) {
          setToken(response.data.token);
          context.commit("setLogged", true);
          resolve();
        })
        .catch(reject);
    });
  },

  forgot(context, { email }) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/accounts/forgot", { email })
        .then(resolve)
        .catch(reject);
    });
  },

  resetPassword(context, { password, token }) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/accounts/reset-password", { password, token })
        .then(resolve)
        .catch(reject);
    });
  },

  get(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/accounts")
        .then(function(response) {
          const user = response.data;
          context.commit("setUser", user);

          resolve();
        })
        .catch(reject);
    });
  },

  acceptedTermCommunity(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/accounts/accepted-term-community")
        .then(function() {
          context.commit("updateUser", { accepted_term_community: true });
          resolve();
        })
        .catch(reject);
    });
  },

  update(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .put("/accounts/", data)
        .then(function() {
          context.commit("updateUser", data);
          resolve();
        })
        .catch(reject);
    });
  },

  updatePerfil(context, perfil) {
    return new Promise((resolve, reject) => {
      window.axios
        .put("/m/accounts/", { perfil })
        .then(function() {
          context.commit("updateUser", { perfil });
          resolve();
        })
        .catch(reject);
    });
  },

  updatePassword(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .put("/accounts/change-password", data)
        .then(resolve)
        .catch(reject);
    });
  }
};
